import BackToPage from './BackToPage.component';
export default BackToPage;